import getVal from "@/utils/get-nested-object-lookup";

/**
 * Sorts array of objects alphabetically depending on the key and the direction
 * (note: case insensitive)
 *
 * @param {String} key Object key to sort by
 * @param {String} direction Direction of sort (enum: ["asc", "desc"])
 */
function alphabetically(key, direction = "asc") {
    const sign = direction === "desc" ? -1 : 1;

    return function(a, b) {
        const aVal = String(getVal(a, key)).toLowerCase();
        const bVal = String(getVal(b, key)).toLowerCase();

        if (aVal < bVal) {
            return -1 * sign;
        }
        if (aVal > bVal) {
            return 1 * sign;
        }
        return 0;
    };
}

/**
 * Sorts array of objects chronologically depending on the key and the direction
 * (note: case insensitive)
 *
 * @param {String} key Object key to sort by
 * @param {String} direction Direction of sort (enum: ["asc", "desc"])
 */
function chronologically(key, direction = "asc") {
    const sign = direction === "desc" ? -1 : 1;

    return function(a, b) {
        const aVal = Date.parse(getVal(a, key)) || Infinity;
        const bVal = Date.parse(getVal(b, key)) || Infinity;

        if (aVal < bVal) {
            return -1 * sign;
        }
        if (aVal > bVal) {
            return 1 * sign;
        }
        return 0;
    };
}

/**
 * Sorts array of objects numerically depending on the key and the direction
 * (note: case insensitive)
 *
 * @param {String} key Object key to sort by
 * @param {String} direction Direction of sort (enum: ["asc", "desc"])
 */
function numerically(key, direction = "asc") {
    const sign = direction === "desc" ? -1 : 1;

    return function(a, b) {
        const aVal = Number(getVal(a, key));
        const bVal = Number(getVal(b, key));

        if (aVal < bVal) {
            return -1 * sign;
        }
        if (aVal > bVal) {
            return 1 * sign;
        }
        return 0;
    };
}

export default {
    alphabetically,
    chronologically,
    numerically,
};

export { alphabetically, chronologically, numerically };
